import React from 'react';
import { Form, Input } from 'antd';
import { FileTextOutlined, IdcardOutlined, PhoneOutlined, ToolOutlined, TruckOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { TransportRouteDetailDto } from '../dto/transport';
import TransportFormSection from './TransportFormSection';

const { TextArea } = Input;

interface TransportVehicleNotesSectionProps {
  /** Section number (owner 2026-10-10: „Gdzie jedzie” shifts the following sections). */
  step?: number;
  transport?: TransportRouteDetailDto | null;
  isEditMode: boolean;
}

const TransportVehicleNotesSection: React.FC<TransportVehicleNotesSectionProps> = ({
  step = 5,
  transport,
  isEditMode,
}) => {
  const { t } = useTranslation(['transport']);
  const hasVehicleData = [
    transport?.licensePlate1,
    transport?.licensePlate2,
    transport?.driverName,
    transport?.driverPhone,
  ].some((value) => String(value ?? '').trim().length > 0);

  return (
    <TransportFormSection
      sectionKey="vehicle"
      step={step}
      icon={<ToolOutlined />}
      label={t('transport:sections.vehicleDriver')}
      summary={isEditMode && hasVehicleData ? [transport?.licensePlate1, transport?.driverName].filter(Boolean).join(' · ') : undefined}
    >
      {/* Owner 2026-10-10: vehicle and driver as two small cards. */}
      <div className="transport-vehicle-grid">
        <div className="transport-vehicle-card">
          <div className="transport-vehicle-card__head"><TruckOutlined aria-hidden="true" /> {t('transport:vehicleCard.vehicle')}</div>
          <div className="transport-vehicle-card__fields">
            <Form.Item name="licensePlate1" label={t('transport:fields.licensePlate1')} style={{ marginBottom: 0 }}>
              <Input prefix={<IdcardOutlined aria-hidden="true" />} placeholder={t('transport:placeholders.licensePlate')} />
            </Form.Item>
            <Form.Item name="licensePlate2" label={t('transport:fields.licensePlate2')} style={{ marginBottom: 0 }}>
              <Input prefix={<IdcardOutlined aria-hidden="true" />} placeholder={t('transport:placeholders.licensePlate')} />
            </Form.Item>
          </div>
        </div>
        <div className="transport-vehicle-card">
          <div className="transport-vehicle-card__head"><UserOutlined aria-hidden="true" /> {t('transport:vehicleCard.driver')}</div>
          <div className="transport-vehicle-card__fields">
            <Form.Item name="driverName" label={t('transport:fields.driverName')} style={{ marginBottom: 0 }}>
              <Input prefix={<UserOutlined aria-hidden="true" />} placeholder={t('transport:placeholders.driverName')} />
            </Form.Item>
            <Form.Item name="driverPhone" label={t('transport:fields.driverPhone')} style={{ marginBottom: 0 }}>
              <Input prefix={<PhoneOutlined aria-hidden="true" />} placeholder={t('transport:placeholders.driverPhone')} />
            </Form.Item>
          </div>
        </div>
      </div>
      <Form.Item
        name="notes"
        label={(
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <FileTextOutlined aria-hidden="true" />
            {t('transport:fields.notes')}
          </span>
        )}
        style={{ marginTop: 16, marginBottom: 0 }}
      >
        <TextArea rows={3} placeholder={t('transport:placeholders.notes')} />
      </Form.Item>
    </TransportFormSection>
  );
};

export default TransportVehicleNotesSection;
